<template>
  <svg
    width="23"
    height="27"
    viewBox="0 0 23 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_40002730_3682"
      style="mask-type: alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="23"
      height="27"
    >
      <path
        d="M21.1397 26.0557H1.86029C0.832882 26.0557 0 25.2242 0 24.1985V1.91281C0 0.887136 0.832882 0.0556641 1.86029 0.0556641H14.375L23 8.66605V24.1985C23 25.2242 22.1671 26.0557 21.1397 26.0557Z"
        fill="url(#paint0_linear_40002730_3682)"
      />
    </mask>
    <g mask="url(#mask0_40002730_3682)">
      <path
        d="M21.1397 26.0557H1.86029C0.832882 26.0557 0 25.2242 0 24.1985V1.91281C0 0.887136 0.832882 0.0556641 1.86029 0.0556641H14.375L23 8.66605V24.1985C23 25.2242 22.1671 26.0557 21.1397 26.0557Z"
        fill="url(#paint1_linear_40002730_3682)"
      />
      <g filter="url(#filter0_d_40002730_3682)">
        <path
          d="M23 8.66605H16.375C15.2704 8.66605 14.375 7.77062 14.375 6.66605V0.0556641L23 8.66605Z"
          fill="url(#paint2_linear_40002730_3682)"
        />
      </g>
      <path
        d="M11 20.4583V12M11 12L7.5 15.5M11 12L14.5 15.5"
        stroke="white"
        stroke-width="1.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_40002730_3682"
        x="-8.625"
        y="-23.9443"
        width="58.625"
        height="58.6104"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset
          dx="2"
          dy="1"
        />
        <feGaussianBlur stdDeviation="12.5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.33 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_40002730_3682"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_40002730_3682"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_40002730_3682"
        x1="11.5"
        y1="0.0556641"
        x2="11.5"
        y2="26.0557"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FF7979" />
        <stop
          offset="1"
          stop-color="#E85555"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_40002730_3682"
        x1="11.5"
        y1="0.0556641"
        x2="11.5"
        y2="26.0557"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#CFCFCF" />
        <stop
          offset="1"
          stop-color="#ADADAD"
        />
      </linearGradient>
      <linearGradient
        id="paint2_linear_40002730_3682"
        x1="18.6875"
        y1="0.0556641"
        x2="18.6875"
        y2="8.66605"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#A8A8A8" />
        <stop
          offset="1"
          stop-color="#787878"
        />
      </linearGradient>
    </defs>
  </svg>
</template>
